import config from './config.yaml';
import {addZoomIn} from 'component/zoom-in';
import {addExcelExport} from 'component/excel-export';
const text = require('./text.yaml')[templateVars.lang];
const maximumScaling = 6;
const expandClass = 'is-expand';

/**
 * Масштабирование больших таблиц
 */
function scaleLargeTables($this) {
	var contentWidth = $this.parent().width();
	var $table = $this.find('table');

	/**
	 * Условие для проверки класса
	 */
	if (!$this.hasClass('table--no-scale')) {
		for (var i = 1; $table.width() > contentWidth && i < maximumScaling; i++) {
			$this.addClass('table--scale-' + i).removeClass('table--scale-' + (i - 1));
		}
	}
}

/**
 * Фиксирование шапки таблицы
 */
function fixedHead($tables) {
	$tables.each(function () {
		const $thisTable = $(this);
		const $fixedTable = $thisTable.find('.fixed-head');
		const headHeight = $fixedTable.height();
		const tableTop = $thisTable.offset().top;
		const tableBot = $thisTable.offset().top + $thisTable.height() - headHeight;
		const scrollTop = $(window).scrollTop();

		if (scrollTop > tableTop && scrollTop < tableBot && $fixedTable.is(':hidden')) {
			$fixedTable.css('display', 'block');
		} else if ($fixedTable.is(':visible') && !(scrollTop > tableTop && scrollTop < tableBot)) {
			$thisTable.find('.fixed-head').hide();
		}
	});
}

/**
 * Добавление скрытой шапки, которая будет фиксироваться
 */
function addHeadForFixed($this) {
	const tableWidth = $this.width();
	const tableCaption = $this.find('caption').html();
	const tableHead = $this.find('thead').html();
	const tableHeadCells = $this.find('thead').find('th');

	$this.append(`<table class="fixed-head"><caption>${tableCaption}</caption><thead>${tableHead}</thead></table>`);

	const $fixedTable = $this.find('.fixed-head');
	const fixedCells = $fixedTable.find('th');

	$fixedTable.width(tableWidth);

	tableHeadCells.each(function (i) {
		fixedCells.eq(i).width($(this).width());
	});
}

/**
 * Показ всех строчек таблицы
 * @param $rows - строчки для показа
 * @param button - кнопка-тогл
 */
function showRows($rows, button) {
	//показыаем все строки
	$rows.show();
	//добавляем класс раскрытия
	button.addClass(expandClass);
	//меняем текст на тогле
	button.html(text.hideAllRowsButton);
}

/**
 * Скрытие строчек в таблице
 * @param $rows - строки таблицы
 * @param visibleRows - количество строчек, которые нужно оставить показанным
 * @param button - кнопка-тогл
 */
function hideRows($rows, visibleRows, button) {
	//скрываем все строки, кроме минимального количества видимых
	$rows
		.not($rows.slice(0, visibleRows))
		.hide();

	//удаляем классы раскрытия
	button.removeClass(expandClass);
	//меняем текст на тогле
	button.html(text.showAllRowsButton);
	//скролим к таблице
	$('html,body').animate({scrollTop: button.closest('.table').offset().top}, 'slow');
}

/**
 * Переключение состоянии таблицы - показывать переданные строки или скрывать
 * @param $rows - строки
 * @param visibleRows - количество, которое нужно оставлять показанным
 * @param button - кнопка-тогл
 */
function toggleVisibleRows($rows, visibleRows, button) {
	//Если у обработчика есть класс раскрытия, т.е. блок нужно сворачивать
	if (button.hasClass(expandClass)) {
		hideRows($rows, visibleRows, button);
	} else {
		showRows($rows, button);
	}
}

/**
 * Метод добавляет кнопку показа-скрытия дополнительных строк в таблице
 * @param $table - контейнер таблицы
 * @param visibleRows - количество строчек, который нужно оставлять раскрытыми
 */
function addToggleVisibleRowsButton($table, visibleRows) {
	let $toggle = $table.find('.js-toggle-visible-rows'); //Пытаемся найти элемент с созданной ранее кнопкой
	let $rows = $table.find('tbody>tr'); //Получаем все строчки в tbody

	//Количество найденных строк больше, чем минимально показываемое количество?
	if ($rows.length > visibleRows) {
		//Была ли добавлена ранее кнопка?
		if ($toggle.length) {
			return false;
		} else {
			//Создаем элемент кнопки
			let button = $('<button class="table__toggle-visible-rows-trigger js-toggle-visible-rows"/>');
			//Прописываем название кнопки
			button.html(text.showAllRowsButton);
			//Добавляем кнопку в элеменет таблицы
			$table.append(button);

			//Создаем обработчик события клик
			button.on('click', () => toggleVisibleRows($rows, visibleRows, button));

			//скрываем строки посли подгрузки кнопки
			hideRows($rows, visibleRows, button);
		}
	}
}

/**
 * Делает строки таблицы выделяемым
 * @param $tableRow - строки таблицы
 */
function makeSelectable($table) {
	let $tableRow = $table.find('tr');

	$tableRow.on('click', function () {
		const $this = $(this);

		if ($this.hasClass('selected-row')) {
			$this.removeClass('selected-row');
		} else {
			$this.addClass('selected-row');
		}
	});
}

//Повторный вызов функций для созданной таблицы в модалке
$(document).bind('cbox_complete', function () {
	const $colorboxTable = $('#colorbox .table');

	//Проверка конфига на то, что нужно делать строки выделяемыми
	if ($colorboxTable.length && config.selectableRows) {
		makeSelectable($colorboxTable);
	}
});

$(document).ready(function () {
	$('.table').each(function (index, el) {
		const $this = $(this);

		if (!$this.find('.figure-buttons.js-buttons').length) {
			$this.append('<div class="figure-buttons js-buttons"></div>');
		}

		if (!$this.hasClass('table--no-xls') && addExcelExport) {
			addExcelExport($this);
		}

		if (!$this.hasClass('table--no-zoom')) {
			addZoomIn($this);
		}

		scaleLargeTables($this);

		if (config.fixedHead) {
			addHeadForFixed($this);
		}

		//Проверка конфига на то, что нужно делать строки выделяемыми
		if (config.selectableRows) {
			makeSelectable($this);
		}

		//Параметр количества показываемых по умолчанию строчек
		let visibleRowsCount = $this.attr('data-visible-rows');
		if (typeof visibleRowsCount != 'undefined') {
			addToggleVisibleRowsButton($this, visibleRowsCount);
		}
	});

	if (config.fixedHead && $('.table').length) {
		const $tables = $('.table');

		$(window).scroll(function () {
			setTimeout(fixedHead($tables), 0);
		});
	}
});



// WEBPACK FOOTER //
// ./temp/components/tables/index.js